import "./page-interactive-eossat.scss";
import "./jquery.easing.1.3";


var videoPlayer = document.getElementById('video');
var blockWrap = document.getElementsByClassName('bg-block-wrap');
var time = 10000;
var step = 1;

function initSlider(sliderName, sliderAttr, sliderAttrControls) {
  const $slideBlockWrap = jQuery('#' + sliderName);
  var dataActiveSlide = Number($slideBlockWrap.attr(sliderAttr));


  $("[" + sliderAttrControls + "]").on('click', function () {
    var initSlideNumber = Number($(this).attr(sliderAttrControls));
    $slideBlockWrap.attr(sliderAttr, initSlideNumber);
    video.pause();
    video.currentTime = 0;
    $('.bg-block-wrap').animate({ scrollTop: 0 }, 0);
  });
}





initSlider("slider-main", "data-slide-active", "data-init-slide");
initSlider("slide-5-steps", "data-step-active", "data-init-step");
initSlider("sliderAssemblys", "data-assembly-active", "data-init-assembly");

//Slide 2

$('[data-init-assembly]').on('click', function () {
  console.log($("#sliderAssemblys").attr("data-assembly-active"));

  if ($("#sliderAssemblys").attr("data-assembly-active") >= 7) {
    setTimeout(function () {
      $('#slider-main').attr('data-slide-active', 3);
    }, 3500);

  }
});

//Slide 3

$('#videoStart').on('click', function () {
  $('#slider-main').attr('data-slide-active', 4);

  setTimeout(function () {
    videoPlayer.play();
  }, 3800);

  setTimeout(function () {

    $('#num').each(function () {
      var $this = $(this),
        countTo = 540;

      $({ countNum: $this.text() }).animate({
        countNum: countTo
      },
        {
          duration: 19200,
          easing: 'easeInQuint',
          step: function () {
            $this.text(Math.floor(this.countNum) - 3);
          },
          complete: function () {
            $this.text(this.countNum);
          }

        });

    });
  }, 2100);

});

// Slide 4

videoPlayer.onended = function () {
  $('#slider-main').attr('data-slide-active', 5);
  $('#num').text(0)
};

//Slide 5

$('.container.modal .btn').on('click', function () {
  $('#slide-5-steps').attr('data-step-active', 2);

  setTimeout(function () {
    $('#slide-5-steps').attr('data-step-active', 3);
  }, 1500);
});

$('.container.block-1 .btn-white').on('click', function () {
  $('#slide-5-steps').attr('data-step-active', 2);

  setTimeout(function () {
    $('#slide-5-steps').attr('data-step-active', 1);
  }, 1000);
});


$('[data-init-slide]').on('click', function () {
  $('#slide-5-steps').attr('data-step-active', 1);
  $('#sliderAssemblys').attr('data-assembly-active', 1);
});
